import React from 'react'
import { View, ViewStyle, TextStyle, Switch } from 'react-native'
import { Header, color, Text, spacing, iconArrowBack } from '@trivie/ui-mobile'
import { RadioGroupWeb as RadioGroup } from '@trivie/ui-mobile'
import { useStores } from '@trivie/core'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router'

export const QuizzesTestsScreen = observer(() => {
  const history = useHistory()
  const goBack = () => history.goBack()
  const { userStore } = useStores()
  const { user } = userStore

  if (!user) {
    return null
  }
  const { user_comm_settings } = user

  return (
    <View testID="QuizzesTestsScreen" style={FULL}>
      <div style={CONTAINER}>
        <Header
          leftIcon={iconArrowBack}
          onLeftPress={goBack}
          center
          titleStyle={HEADER}
          style={{ marginBottom: 12 }}
          headerTx="Settings.Notifications.quizTest"
        />

        <fieldset style={FIELDSETS}>
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <View style={{ display: 'flex', flexDirection: 'column' }}>
              <Text variant="label" tx="Quiz.quizzes" />
              <Text variant="body2" tx="" style={{ color: color.shade50 }} />
            </View>
            <Switch
              // @ts-ignore
              dataSet={{ qat: `quizzes_notification_toggle` }}
              accessible
              accessibilityRole="switch"
              accessibilityLabel="[Feed Activity Emails]"
              trackColor={{ true: color.green, false: color.darkenGrey }}
              thumbColor="white"
              value={user_comm_settings?.push_notify_quizzes === 'When available'}
              onValueChange={(value) =>
                userStore.setUserCommSettings({
                  push_notify_quizzes: value ? 'When available' : 'Off',
                })
              }
            />
          </View>
          <View
            style={{
              paddingVertical: 20,
              paddingTop: 20,
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <View style={{ display: 'flex', flexDirection: 'column' }}>
              <Text variant="label" tx="Quiz.tests" />
              <Text variant="body2" tx="" style={{ color: color.shade50 }} />
            </View>
            <Switch
              // @ts-ignore
              dataSet={{ qat: `tests_notification_toggle` }}
              accessible
              accessibilityRole="switch"
              accessibilityLabel="[Feed Activity Emails]"
              trackColor={{ true: color.green, false: color.darkenGrey }}
              thumbColor="white"
              value={user_comm_settings?.push_notify_tests === 'When available'}
              onValueChange={(value) =>
                userStore.setUserCommSettings({
                  push_notify_tests: value ? 'When available' : 'Off',
                })
              }
            />
          </View>
        </fieldset>
      </div>
    </View>
  )
})

/**
 * Styling
 */
const FULL: ViewStyle = { flex: 1 }
const CONTAINER: React.CSSProperties = { backgroundColor: color.white }
const FIELDSETS: React.CSSProperties = { padding: 0, border: 'none' }
const TOGGLE_WRAPPER: React.CSSProperties = { display: 'flex', justifyContent: 'space-between' }
const HEADER: TextStyle = { fontSize: 24, color: color.black }
